/* eslint-disable no-undef */

import { API_URL } from '../../api-config';
import { useState,useEffect} from "react";
import { PowerBIEmbed } from 'powerbi-client-react';
import { models} from 'powerbi-client';
import axios from "axios";
import './index.css'
const BiReport = ({ id }) => {
  const [isFullscreen] = useState(true);
  const [biToken,setBiToken] = useState("");
  // const toggleFullscreen = () => {
  //   window.report.fullscreen()
  // };
  let mail = "sixbell@qrtsolutions.com";
  
      
  if (id == "4f689b8b-bf1a-4396-949d-2b9428abade0"){
    mail = "sixbell@qrtsolutions.com"
  } else if (id == "3a8bc423-80ce-42d8-8f97-80d834db8fec"){
    mail = "cheil@qrtsolutions.com"
  }

  let groupId = "";
  let embedReportId = "";
  let token = ""
  useEffect(() =>  { // Reemplaza con tu URL de API
    console.log('llegue 1')
    const fetchData = async () => {
    await axios.post(`${API_URL}/token`, `grant_type=&username=${mail}&password=${"123456"}&scope=&client_id=&client_secret=`, { headers: { "Content-Type": "application/x-www-form-urlencoded" }})
      .then((e) => {
          token = e.data.access_token;
          console.log(token);
          
          
      }).catch((error) => {
        console.log(error);})

      await axios.get(`
              ${API_URL}/reports/${id}`, {
              headers: {
                  "accept": "application/json",
                  "Authorization": "Bearer " + token,
              }
              }).then((response)=>{
                  const info = response.data;
                  groupId = info.group_id
                  embedReportId = info.report_id
                  console.log(info,"INFO")
                  
              }).catch((error)=>console.log(error))
              await axios.get(`${API_URL}/users/bi_tokens`, {
                headers: {
                    "accept": "application/json",
                    "Authorization": "Bearer " + token,
                }
              }).then((response)=>{
                  setBiToken(response.data.bi_token);
                  console.log("BI TOKEN ", response.data.bi_token);
              }).catch((error) => console.log(error));
          
          }

          fetchData()
}, []); 
  // if (token != ""){
  //   await 
  // }


  return (


        <div className = "w-screen h-screen p-12">
        {/* <div id="reportContainer"> */}
        {biToken != ""?
        <PowerBIEmbed
          embedConfig={{
            type: 'report',   // Supported types: report, dashboard, tile, visual and qna
            id: id,
            // pageView: "fitToWidth",
            embedUrl:`https://app.powerbi.com/reportEmbed?reportId=${embedReportId}&groupId=${groupId}&w=2&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly9XQUJJLVBBQVMtMS1TQ1VTLXJlZGlyZWN0LmFuYWx5c2lzLndpbmRvd3MubmV0IiwiZW1iZWRGZWF0dXJlcyI6eyJtb2Rlcm5FbWJlZCI6dHJ1ZSwidXNhZ2VNZXRyaWNzVk5leHQiOnRydWV9fQ%3d%3d`,
            accessToken: biToken,
            tokenType: models.TokenType.Aad,
            settings: {
              panes: {
                filters: {
                  expanded: false,
                  visible: false
                }
                ,
                fullscreen: isFullscreen,
              },
            }
          }}
          eventHandlers={
            new Map([
              [
                'loaded', 
                function () { 
                  console.log('Report loaded'); 
                }
              ],
              [
                'rendered', 
                function () { 
                  console.log('Report rendered'); 
                }
              ],
              [
                'error', 
                function (event) {
                  console.log(event.detail); 
                }
              ]
            ])
          }
          cssClassName={"Embed-container"}
          getEmbeddedComponent={(embeddedReport) => {
            window.report = embeddedReport;
          }}
        /> :null
      }
        
        {/* </div> */}
        </div>

  )
}

export default BiReport;